export const getGender = (gender: string | number): string => {
  if (typeof gender === 'number' || ['0', '1'].includes(gender)) {
    return gender === 1 ? 'male' : 'female'
  }

  if (['F', 'M'].includes(gender)) {
    return gender === 'F' ? 'female' : 'male'
  }

  return gender === 'male' ? '1' : '0'
}

export const parseDDMMYYYY = (dateString: string): Date => {
  const [day, month, year] = dateString.split('/')
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
}

export const checkImageDimensions = (
  file: File,
  minWidth: number,
  minHeight: number
): Promise<boolean> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    const url = URL.createObjectURL(file)

    img.onload = () => {
      URL.revokeObjectURL(url)

      const actualWidth = img.naturalWidth
      const actualHeight = img.naturalHeight

      const isValidSize = actualWidth >= minWidth && actualHeight >= minHeight

      resolve(isValidSize)
    }

    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(false)
    }

    img.src = url
  })

export const getBaseUrlForDocuments = () =>
  import.meta.env.MODE === 'development' ? 'https://qatar.qic-dev.online' : '/'
